/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 01/13/2021
 *
 * @version 0.2
 * Revisions:
 * 01/13/2021 - BW - Initial Creation
 * 04/07/2022 - BW - Added: invalidPaymentFeList
 * 06/17/2022 - BW - Added: invalidPaymentFe2List, invalidPaymentFe3List
 *
 * Description/Purpose:
 * Payment Ajax Response Json DTO
 ************************************************************** */
import BasicAjaxResponseJSONDTO from "dto/basic-ajax-response-json-dto";


export default class PaymentAjaxResponseJsonDto extends BasicAjaxResponseJSONDTO {
  constructor(obj) {
    super(obj);
    if (obj) Object.assign(this, obj);
  }

  get token() {
    return this._token;
  }

  set token(newToken) {
    this._token = newToken;
  }

  get invalidInvoiceNumberFeList() {
    return this._invalidInvoiceNumberFeList;
  }

  set invalidInvoiceNumberFeList(newInvalidInvoiceNumberFeList) {
    this._invalidInvoiceNumberFeList = newInvalidInvoiceNumberFeList;
  }

  get invalidPaymentFeList() {
    return this._invalidPaymentFeList;
  }

  set invalidPaymentFeList(newInvalidPaymentFeList) {
    this._invalidPaymentFeList = newInvalidPaymentFeList;
  }

  get invalidPaymentFe2List() {
    return this._invalidPaymentFe2List;
  }

  set invalidPaymentFe2List(newInvalidPaymentFe2List) {
    this._invalidPaymentFe2List = newInvalidPaymentFe2List;
  }

  get invalidPaymentFe3List() {
    return this._invalidPaymentFe3List;
  }

  set invalidPaymentFe3List(newInvalidPaymentFe3List) {
    this._invalidPaymentFe3List = newInvalidPaymentFe3List;
  }

}
